import {s} from "@/edinet/libs/utils";
import $ from "jquery"

/**
 * more efficient than filter because it will stop iterating once found
 * @param filter
 * @return {[*, *]} array of size 2: [(before first match), (first match)]
 */
$.fn.any = function(filter: (e: HTMLElement) => boolean) {
    for (let i = 0; i < this.length; i++) {
        if (filter.call(/*this*/this, /*1st arg (e)*/this[i])) return [this[i - 1], this[i]]
    }
}

function findNodesWithNames(regexs: string[]) {
    //todo: fix this hardcode #jq-root
    return $('#jq-root').find('span,p,div').filter((_, x) => {
        let found = false
        for (const r of regexs) {
            if ($(x).text().match(r)) {
                found = true
                break
            }
        }
        return found
    }).get()
}

function hasNodesWithNames(regexs: string[]) {
    //todo: fix this hardcode #jq-root
    return $('#jq-root').find('span,p,div').any((x) => {
        let found = false
        for (const r of regexs) {
            if ($(x).text().match(r)) {
                found = true
                break
            }
        }
        return found
    })
}

function scrollToNode(n: HTMLElement) {
    n.scrollIntoView()
    $(n).addClass('scroll-highlight')
    setTimeout(() => {
        $(n).removeClass('scroll-highlight')
    }, 1000) //create transition effect when scroll
}

function scrollToTheNextNodeFromView(nodes: HTMLElement[]) {
    //jump to the next node from current offset
    const currentTop = window.scrollY + 10 //add some offset so we can jump to the next node
    let found = false

    for (const n of nodes) {
        const offset = $(n).offset()
        // console.log('%o vs %o (%o)', currentTop, top, n)
        if ((offset !== undefined) && offset.top > currentTop) {
            found = true
            scrollToNode(n)
            break
        }
    }
    if (!found) {
        //loop to the first node if not found
        scrollToNode(nodes[0])
    }
}

export const findTableWithNf = function(nonfractions: string[]): HTMLElement[] {
    const selector = nonfractions.map(x => s(`ix:nonfraction[name=${x}]`)).join(',')
    const res = $(selector).parentsUntil('table')
        .parent()
        .filter((_, x) => x.tagName === 'TABLE')
        .get()
    return res
}

export const scrollToTableWithNf = function(nonfractions: string[]) {
    const tables = findTableWithNf(nonfractions)
    if (tables.length === 0) {
        console.warn('table not found for nonfractions: %o', nonfractions)
    } else {
        scrollToTheNextNodeFromView(tables)
    }
}

export const hasTableWithNf = function(nonfractions: string[]): boolean {
    return findTableWithNf(nonfractions).length > 0
}

export const scrollToText = function(regexs: string[]) {
    const spans = findNodesWithNames(regexs)
    if (spans.length === 0) {
        console.warn('span,div,p node not found for regexs: %o', regexs)
    } else {
        scrollToTheNextNodeFromView(spans)
    }
}

export const textExists = function(regexs: string[]): boolean {
    return hasNodesWithNames(regexs)
}

export const scrollToIxTag = function(tag: string, name: string, contextRef: string) {
    const selector = s(`ix:${tag}[name=${name}][contextref=${contextRef}]`)
    const $sel = $(selector)
    const res = $sel.get()
    if (res.length > 0) {
        scrollToNode(res[0])
    } else {
        console.warn('cannot find element to scroll to: %o', selector)
    }
}
export const scrollToIx = function(names: string[]) {
    const selector = names.map(x => s(`ix:nonnumeric[name=${x}],ix:nonfraction[name=${x}]`)).join(',')
    const $sel = $(selector)
    if ($sel.prop('tagName') === 'IX:NONNUMERIC') { //use parent if it's non html tag
        const res = $sel.parent().get()
        if (res.length > 0) {
            scrollToNode(res[0])
        } else {
            console.warn('cannot find element to scroll to: %o', selector)
        }
    } else {
        const res = $sel.get()
        if (res.length > 0) {
            scrollToNode(res[0])
        } else {
            console.warn('cannot find element to scroll to: %o', selector)
        }
    }
}

export const ixExists = function(names: string[]): boolean {
    const selector = names.map(x => s(`ix:nonnumeric[name=${x}],ix:nonfraction[name=${x}]`)).join(',')
    return $(selector).length > 0
}

function findClosetNonumerics(currentTop: number) {
    return $(s('ix:nonnumeric')).any(function(e: HTMLElement) {
        const offset = $(e).offset()
        return (offset !== undefined) && offset.top > currentTop
    })
}

export const scrollNext = function() {
    //need to add some offset, so it doesn't return the same element
    const currentTop = window.scrollY + 10
    const next = findClosetNonumerics(currentTop)
    if (next) {
        scrollToNode(next[1])
    } else {
        console.warn('no next ix:nonnumeric')
    }
}

export const scrollPrev = function() {
    //need to add some offset, so it doesn't return the same element
    const currentTop = window.scrollY - 10
    const prev = findClosetNonumerics(currentTop)
    if (prev) {
        scrollToNode(prev[0])
    } else {
        console.warn('no prev ix:nonnumeric')
    }
}
